import {Action, Store} from "@reduxjs/toolkit"

export const SET_LANGUAGE = "SET_LANGUAGE"

interface SetLanguage {
    type: typeof SET_LANGUAGE
    languageSelectorData: LanguageDuckState
}

interface AltLanguages {
    altLanguageName: string
    altLanguageUrl: string
}

export interface LanguageDuckState {
    currentLanguageText: string
    currentLanguageName: string
    direction: string
    siteUrl: string
    altLanguages: AltLanguages[]
}

export const initialState: LanguageDuckState = {
    currentLanguageText: "",
    currentLanguageName: "",
    direction: "ltr",
    siteUrl: "",
    altLanguages: [],
}

export const setLanguageIds = (languageSelectorData: LanguageDuckState): SetLanguage => ({
    type: SET_LANGUAGE,
    languageSelectorData,
})

const reducer = (state: LanguageDuckState = initialState, action: SetLanguage): LanguageDuckState => {
    switch (action.type) {
        case SET_LANGUAGE:
            return {...action.languageSelectorData}
        default:
            return state
    }
}

export const updateLanguage = (store: Store, languageSelectorData: LanguageDuckState) => {
    store.dispatch<Action>(setLanguageIds(languageSelectorData))
}

export default reducer
